import { template as _$template } from "solid-js/web";
import { delegateEvents as _$delegateEvents } from "solid-js/web";
import { memo as _$memo } from "solid-js/web";
import { classList as _$classList } from "solid-js/web";
import { effect as _$effect } from "solid-js/web";
import { setAttribute as _$setAttribute } from "solid-js/web";
import { mergeProps as _$mergeProps } from "solid-js/web";
import { insert as _$insert } from "solid-js/web";
import { createComponent as _$createComponent } from "solid-js/web";
var _tmpl$ = /*#__PURE__*/_$template(`<div class="flex flex-col sm:flex-row gap-x-2 items-center justify-center"><span>❤️</span><span>Deck</span><span>Darlings`),
  _tmpl$2 = /*#__PURE__*/_$template(`<div class="flex flex-col sm:flex-row gap-x-2 items-center justify-center"><span>⚡</span><span>Payday</span><span>Picks`),
  _tmpl$3 = /*#__PURE__*/_$template(`<div class="flex flex-col sm:flex-row items-center justify-center gap-x-2"><span>🧑‍🚀</span><span>Pathfinders`),
  _tmpl$4 = /*#__PURE__*/_$template(`<p>With <a href=https://podcasting2.org/podcast-namespace/tags/valueTimeSplit target=_blank rel=noreferrer title="Opens in a new tab">wallet switching technology</a>, podcasters can share listener payments with the artists whose music they feature! This is a ranking of tracks that have been the <strong>most widely played</strong> by these value-for-value DJs in the <strong>last 60 days</strong>.`),
  _tmpl$5 = /*#__PURE__*/_$template(`<div class="flex items-center gap-x-5 justify-center"><a class="muted flex items-center gap-x-1 text-xs hover:text-primary-500 custom-transition cursor-pointer"href=/static/dist/feeds/deck-darlings.xml target=_blank rel=noreferrer><span>Subscribe`),
  _tmpl$6 = /*#__PURE__*/_$template(`<ol class="not-prose flex flex-col gap-y-5 mt-10">`),
  _tmpl$7 = /*#__PURE__*/_$template(`<p>We look for podcast episodes published in the last 60 days that reference music tracks using the <a href=https://podcasting2.org/podcast-namespace/tags/valueTimeSplit target=_blank rel=noreferrer title="Opens in a new tab"><code>&lt;podcast:valueTimeSplit></code></a> tag in the RSS feed. This tag enables the podcaster to share listener payments with the artist during a segment of the episode. It is a strong signal that the track was played.`),
  _tmpl$8 = /*#__PURE__*/_$template(`<p>The tracks are ranked by the number of <em>unique</em> podcasts that have these references—if a track is played in the same podcast multiple times, it is only counted once. If several tracks have the same number of unique references, ones with the most recent average publish date of the referencing episodes are ranked higher, i.e., recent plays are given more weight.`),
  _tmpl$9 = /*#__PURE__*/_$template(`<p>Clicking on a track will display <em>all</em> the episodes that featured it since it was first uploaded. The ranking is updated every hour.`),
  _tmpl$10 = /*#__PURE__*/_$template(`<p>Listeners on <a href=https://modernpodcastapps.com/ target=_blank rel=noreferrer title="Opens in a new tab">modern podcast apps</a> can send direct payments to the artists whose music they love. This is a ranking of tracks that have received the <strong>greatest number of listener payments</strong> in the <strong>last 7 days</strong>!`),
  _tmpl$11 = /*#__PURE__*/_$template(`<div class="flex items-center gap-x-5 justify-center"><a class="muted flex items-center gap-x-1 text-xs hover:text-primary-500 custom-transition cursor-pointer"href=/static/dist/feeds/payday-picks.xml target=_blank rel=noreferrer><span>Subscribe`),
  _tmpl$12 = /*#__PURE__*/_$template(`<ol class="not-prose flex flex-col mt-10 gap-y-5">`),
  _tmpl$13 = /*#__PURE__*/_$template(`<p>This ranking is a fork of <span class=font-medium><a href=https://podcastindex.top target=_blank rel=noreferrer title="Opens in a new tab">podcastindex.top`),
  _tmpl$14 = /*#__PURE__*/_$template(`<p><a href=https://podcastindex.org target=_blank rel=noreferrer title="Opens in a new tab">The Podcast Index</a> allows apps to easily retrieve wallet details for individual feeds. For this service, the Index asks for a 1% split. As a side effect, this allows it to observe which tracks are receiving the most payments.`),
  _tmpl$15 = /*#__PURE__*/_$template(`<p>Both one-time payments known as <span class=font-medium>boosts</span> and per-minute payments known as <span class=font-medium>streams</span> are included. The ranking is updated every hour.`),
  _tmpl$16 = /*#__PURE__*/_$template(`<p>One of the greatest things a DJ can do is uncover emerging artists and elevate their music to a wider audience. This ranking of podcasts is based on <strong>first-time plays</strong> of tracks in <strong class=italic>Deck Darlings</strong> and <strong class=italic>Payday Picks</strong> charts!`),
  _tmpl$17 = /*#__PURE__*/_$template(`<div class="flex items-center gap-x-5 justify-center">`),
  _tmpl$18 = /*#__PURE__*/_$template(`<p>The ranking considers the positions of tracks in both <span class="font-medium italic">Deck Darlings</span> and <span class="font-medium italic">Payday Picks</span> charts, with the former given twice the weight.`),
  _tmpl$19 = /*#__PURE__*/_$template(`<p class=mb-0>For a given track in either of the charts, the score associated with it is calculated as:`),
  _tmpl$20 = /*#__PURE__*/_$template(`<p class="text-sm my-2"><var class=not-italic>score</var> = 0.5<sup>(<var class=not-italic>position</var>–1)/10`),
  _tmpl$21 = /*#__PURE__*/_$template(`<p class=mt-0>Simply put, if track <var>B</var> is 10 positions below track <var>A</var>, then <var>A</var> will have twice the score of <var>B</var>. For example, a track at position 7 will have twice the score of a track at position at 17 and four times the score of a track at position 27.`),
  _tmpl$22 = /*#__PURE__*/_$template(`<p class=mb-0>If a podcast was the first to play a track, it receives a score based on the track's position in both charts (with Deck Darlings given twice the weight):`),
  _tmpl$23 = /*#__PURE__*/_$template(`<p class="text-sm my-2"><var class=not-italic>score<sub>total</sub></var> = 2 ×<var class=not-italic>score<sub>Deck_Darlings</sub></var> + <var class=not-italic>score<sub>Payday_Picks`),
  _tmpl$24 = /*#__PURE__*/_$template(`<p class=my-0>For example, a track at position 21 in <em>Deck Darlings</em> and position 31 in <em>Payday Picks</em> will increase the score of the podcast by`),
  _tmpl$25 = /*#__PURE__*/_$template(`<p class="text-sm mt-2">2 × 0.5<sup>(21–1)/10</sup> + 0.5<sup>(31–1)/10</sup> = 2 × 0.25 + 0.125 = 0.625`),
  _tmpl$26 = /*#__PURE__*/_$template(`<p>Clicking on a podcast will show first-time plays of top tracks and their positions. Other first-time plays are not shown. The ranking is updated every hour.`),
  _tmpl$27 = /*#__PURE__*/_$template(`<span>How is this calculated?`),
  _tmpl$28 = /*#__PURE__*/_$template(`<div class="flex items-center justify-between mb-5">`),
  _tmpl$29 = /*#__PURE__*/_$template(`<div class="flex items-center"><div class="relative flex-none mr-5"><div class="flex-none size-24 sm:size-32 bg-gray-200 rounded-xl animate-pulse"></div><div class="absolute size-10 -top-3 -right-3 rounded-full bg-gray-300 animate-pulse"></div></div><div class="flex flex-col gap-y-2 flex-grow"><div class="bg-gray-200 h-8 w-1/2 animate-pulse rounded-md"></div><div class="bg-gray-200 h-5 w-2/5 animate-pulse rounded-md">`),
  _tmpl$30 = /*#__PURE__*/_$template(`<img alt="Cover art"loading=lazy>`),
  _tmpl$31 = /*#__PURE__*/_$template(`<div>`),
  _tmpl$32 = /*#__PURE__*/_$template(`<div class="px-5 py-2 border-b border-gray-200">`),
  _tmpl$33 = /*#__PURE__*/_$template(`<div class="px-5 pt-5 pb-6"><div class="text-gray-800 text-lg font-bold mb-3">Played on:</div><ol class="flex flex-col gap-y-3">`),
  _tmpl$34 = /*#__PURE__*/_$template(`<li><div><div class="relative flex-none"></div><div class="flex flex-col gap-y-1 pr-5 flex-grow min-w-0"><h2 class="text-2xl sm:text-3xl font-bold italic text-gray-800"></h2><h3 class="text-lg font-bold muted">`),
  _tmpl$35 = /*#__PURE__*/_$template(`<a target=_blank rel=noreferrer>`),
  _tmpl$36 = /*#__PURE__*/_$template(`<li class="flex items-center"><span class=leading-normal><span class="text-gray-800 font-medium italic"></span> on <span class="text-gray-800 font-medium"></span><span class="text-xs muted"> (<span class=italic></span>)`),
  _tmpl$37 = /*#__PURE__*/_$template(`<span class="text-left leading-normal">First-time plays <span class="font-normal ml-1">of now-trending tracks:`),
  _tmpl$38 = /*#__PURE__*/_$template(`<ul class="space-y-2 max-h-96 overflow-y-auto">`),
  _tmpl$39 = /*#__PURE__*/_$template(`<div class="px-5 pt-5 pb-6"><ol class="flex flex-col gap-y-3">`),
  _tmpl$40 = /*#__PURE__*/_$template(`<li><div><div class="relative flex-none"></div><div class="flex flex-col gap-y-1 pr-5 flex-grow min-w-0"><h2 class="text-2xl sm:text-3xl font-bold text-gray-800 italic"></h2><h3 class="text-lg font-bold muted">`),
  _tmpl$41 = /*#__PURE__*/_$template(`<li class=text-sm><span class="ml-1 mr-1.5">contributes`),
  _tmpl$42 = /*#__PURE__*/_$template(`<span class="inline-flex ml-1.5 mr-2 bg-red-600 text-white size-6 font-bold rounded-full text-xs items-center justify-center select-none">`),
  _tmpl$43 = /*#__PURE__*/_$template(`<span>`),
  _tmpl$44 = /*#__PURE__*/_$template(`<li class="flex items-center"><span class=leading-normal>by <span class="text-gray-800 font-medium"></span> first featured on <span class="text-gray-800 font-medium"></span><span class="text-xs muted"> (<span class=italic></span>)`),
  _tmpl$45 = /*#__PURE__*/_$template(`<div class="px-5 pt-2 pb-3">`),
  _tmpl$46 = /*#__PURE__*/_$template(`<a target=_blank>`),
  _tmpl$47 = /*#__PURE__*/_$template(`<span class="text-gray-800 font-medium italic"> `),
  _tmpl$48 = /*#__PURE__*/_$template(`<span>2 × 0.5<sup>(<strong></strong>–1)/10</sup> + 0.5<sup>(<strong></strong>–1)/10</sup> <!> `),
  _tmpl$49 = /*#__PURE__*/_$template(`<span>2 × 0.5<sup>(<strong></strong>–1)/10</sup> <!> `),
  _tmpl$50 = /*#__PURE__*/_$template(`<span>0.5<sup>(<strong></strong>–1)/10</sup> <!> `);
import * as HeroMicro from "solid-heroicons/solid-micro";
import * as HeroMini from "solid-heroicons/solid-mini";
import { For, Index, Show, createEffect, createMemo, createSignal, onMount } from "solid-js";
import { EmbeddableAudio } from "./solid";
import { Icon } from "solid-heroicons";
import { Popover } from "@kobalte/core/popover";
import { Tabs } from "@kobalte/core/tabs";
import { timestampToLocalDate } from "./time";
import { render } from "solid-js/web";
import { updateStringParameter } from "./ui";
async function fetch_top_referenced_tracks() {
  // Add a cache buster based on 10-minute intervals
  // Get the current time in milliseconds, divide by the number of milliseconds in 10 minutes (600,000),
  // and take the floor to get a uniform identifier for every 10-minute interval.
  const cacheBuster = Math.floor(Date.now() / 600000);
  const url = `/static/dist/json/top.json?cacheBuster=${cacheBuster}`;
  const response = await fetch(url);
  const json = await response.json();
  return json;
}
const App = () => {
  const query = new URLSearchParams(window.location.search);
  const tabValue = query.get("tab");
  const itemIdValue = query.get("itemId");
  const [tab, setTab] = createSignal(tabValue === "payday-picks" || tabValue === "pathfinders" ? tabValue : "deck-darlings");
  const [topReferencedTracks, setTopReferencedTracks] = createSignal([]);
  const [topBoostedTracks, setTopBoostedTracks] = createSignal([]);
  const [topReferencingFeeds, setTopReferencingFeeds] = createSignal([]);
  onMount(async () => {
    const waitingEl = document.querySelector("div[data-loading]");
    if (waitingEl) {
      waitingEl.remove();
    }
    const top = await fetch_top_referenced_tracks();
    setTopReferencedTracks(top.referenced);
    setTopBoostedTracks(top.boosted);
    setTopReferencingFeeds(top.referencing);
    if (itemIdValue !== null) {
      const el = document.getElementById(itemIdValue);
      if (el) {
        el.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
      }
      // Remove the item ID from the URL
      updateStringParameter("itemId", "");
    }
  });
  const tabName = createMemo(() => {
    switch (tab()) {
      case "deck-darlings":
        return "Deck Darlings";
      case "payday-picks":
        return "Payday Picks";
      case "pathfinders":
        return "Pathfinders";
    }
  });
  createEffect(() => {
    if (tab() !== "deck-darlings") {
      updateStringParameter("tab", tab());
    } else {
      updateStringParameter("tab", "");
    }
  });
  createEffect(() => {
    document.title = `Music Charts - ${tabName()} | RSS Blue`;
  });
  return _$createComponent(Tabs, {
    "aria-label": "Top music charts",
    get value() {
      return tab();
    },
    onChange: setTab,
    get children() {
      return [_$createComponent(Tabs.List, {
        "class": "relative grid grid-cols-3 mb-5 border-b-2 border-gray-300 sm:text-lg font-semibold",
        get children() {
          return [_$createComponent(Tabs.Trigger, {
            value: "deck-darlings",
            get classList() {
              return {
                "py-2": true,
                "cursor-default": tab() === "deck-darlings",
                "hover:bg-gray-200 text-gray-500 hover:text-gray-800": tab() !== "deck-darlings"
              };
            },
            get children() {
              return _tmpl$();
            }
          }), _$createComponent(Tabs.Trigger, {
            value: "payday-picks",
            get classList() {
              return {
                "py-2": true,
                "cursor-default": tab() === "payday-picks",
                "hover:bg-gray-200 text-gray-500": tab() !== "payday-picks"
              };
            },
            get children() {
              return _tmpl$2();
            }
          }), _$createComponent(Tabs.Trigger, {
            value: "pathfinders",
            get classList() {
              return {
                "py-2": true,
                "cursor-default": tab() === "pathfinders",
                "hover:bg-gray-200 text-gray-500": tab() !== "pathfinders"
              };
            },
            get children() {
              return _tmpl$3();
            }
          }), _$createComponent(Tabs.Indicator, {
            get classList() {
              return {
                "absolute -bottom-0.5 border-b-2 transition duration-300 ease-in-out": true,
                "border-red-600": tab() === "deck-darlings",
                "border-yellow-500": tab() === "payday-picks",
                "border-primary-600": tab() === "pathfinders"
              };
            }
          })];
        }
      }), _$createComponent(Tabs.Content, {
        value: "deck-darlings",
        get children() {
          return _$createComponent(TopReferencedTracks, {
            get topReferencedTracks() {
              return topReferencedTracks();
            }
          });
        }
      }), _$createComponent(Tabs.Content, {
        value: "payday-picks",
        get children() {
          return _$createComponent(TopBoostedTracks, {
            get topBoostedTracks() {
              return topBoostedTracks();
            }
          });
        }
      }), _$createComponent(Tabs.Content, {
        value: "pathfinders",
        get children() {
          return _$createComponent(TopReferencingFeeds, {
            get topReferencingFeeds() {
              return topReferencingFeeds();
            }
          });
        }
      })];
    }
  });
};
function TopReferencedTracks(props) {
  const [helpOpen, setHelpOpen] = createSignal(false);
  return [_tmpl$4(), (() => {
    var _el$5 = _tmpl$5(),
      _el$6 = _el$5.firstChild,
      _el$7 = _el$6.firstChild;
    _$insert(_el$6, _$createComponent(Icon, {
      path: HeroMicro.rss,
      "class": "size-4"
    }), _el$7);
    _$insert(_el$5, _$createComponent(HelpDiv, {
      get open() {
        return helpOpen();
      },
      openSetter: setHelpOpen,
      get child() {
        return [_tmpl$7(), _tmpl$8(), _tmpl$9()];
      }
    }), null);
    return _el$5;
  })(), (() => {
    var _el$8 = _tmpl$6();
    _$insert(_el$8, _$createComponent(Show, {
      get when() {
        return props.topReferencedTracks.length === 0;
      },
      get children() {
        return itemPlacholder();
      }
    }), null);
    _$insert(_el$8, _$createComponent(Index, {
      get each() {
        return props.topReferencedTracks;
      },
      children: (track, index) => _$createComponent(TopReferencedTrack, _$mergeProps(() => [track(), index]))
    }), null);
    return _el$8;
  })()];
}
function TopBoostedTracks(props) {
  const [helpOpen, setHelpOpen] = createSignal(false);
  return [_tmpl$10(), (() => {
    var _el$13 = _tmpl$11(),
      _el$14 = _el$13.firstChild,
      _el$15 = _el$14.firstChild;
    _$insert(_el$14, _$createComponent(Icon, {
      path: HeroMicro.rss,
      "class": "size-4"
    }), _el$15);
    _$insert(_el$13, _$createComponent(HelpDiv, {
      get open() {
        return helpOpen();
      },
      openSetter: setHelpOpen,
      get child() {
        return [_tmpl$13(), _tmpl$14(), _tmpl$15()];
      }
    }), null);
    return _el$13;
  })(), (() => {
    var _el$16 = _tmpl$12();
    _$insert(_el$16, _$createComponent(Show, {
      get when() {
        return props.topBoostedTracks.length === 0;
      },
      get children() {
        return itemPlacholder();
      }
    }), null);
    _$insert(_el$16, _$createComponent(Index, {
      get each() {
        return props.topBoostedTracks;
      },
      children: (track, index) => _$createComponent(TopBoostedTrack, _$mergeProps(() => [track(), index]))
    }), null);
    return _el$16;
  })()];
}
function TopReferencingFeeds(props) {
  const [helpOpen, setHelpOpen] = createSignal(false);
  return [_tmpl$16(), (() => {
    var _el$21 = _tmpl$17();
    _$insert(_el$21, _$createComponent(HelpDiv, {
      get open() {
        return helpOpen();
      },
      openSetter: setHelpOpen,
      get child() {
        return [_tmpl$18(), _tmpl$19(), _tmpl$20(), _tmpl$21(), _tmpl$22(), _tmpl$23(), _tmpl$24(), _tmpl$25(), _tmpl$26()];
      }
    }));
    return _el$21;
  })(), (() => {
    var _el$22 = _tmpl$12();
    _$insert(_el$22, _$createComponent(Show, {
      get when() {
        return props.topReferencingFeeds.length === 0;
      },
      get children() {
        return itemPlacholder();
      }
    }), null);
    _$insert(_el$22, _$createComponent(Index, {
      get each() {
        return props.topReferencingFeeds;
      },
      children: (track, index) => _$createComponent(TopReferencingFeed, _$mergeProps(() => [track(), index]))
    }), null);
    return _el$22;
  })()];
}
function HelpDiv(props) {
  return _$createComponent(Popover, {
    fitViewport: true,
    get children() {
      return [_$createComponent(Popover.Trigger, {
        "class": "muted flex items-center gap-x-1 text-xs hover:text-primary-500 custom-transition",
        get children() {
          return [_$createComponent(Icon, {
            path: HeroMicro.questionMarkCircle,
            "class": "size-4"
          }), _tmpl$27()];
        }
      }), _$createComponent(Popover.Portal, {
        get children() {
          return _$createComponent(Popover.Content, {
            "class": "bg-white px-4 pt-2 pb-3 border border-gray-300 shadow-xl rounded-xl max-w-96 sm:max-w-prose z-50",
            get children() {
              return [(() => {
                var _el$33 = _tmpl$28();
                _$insert(_el$33, _$createComponent(Popover.Title, {
                  "class": "font-bold text-lg mb-0",
                  children: "How is this calculated?"
                }), null);
                _$insert(_el$33, _$createComponent(Popover.CloseButton, {
                  get children() {
                    return _$createComponent(Icon, {
                      path: HeroMini.xMark,
                      "class": "size-5"
                    });
                  }
                }), null);
                return _el$33;
              })(), _$createComponent(Popover.Description, {
                "class": "text-sm",
                get children() {
                  return props.child;
                }
              })];
            }
          });
        }
      })];
    }
  });
}
function itemPlacholder() {
  return _tmpl$29();
}
function TopReferencedTrack([track, index]) {
  const [open, setOpen] = createSignal(false);
  const coverArt = track.trackCoverArtUrl || track.albumCoverArtUrl;
  return (() => {
    var _el$35 = _tmpl$34(),
      _el$36 = _el$35.firstChild,
      _el$37 = _el$36.firstChild,
      _el$40 = _el$37.nextSibling,
      _el$41 = _el$40.firstChild,
      _el$42 = _el$41.nextSibling;
    _el$36.$$click = () => setOpen(!open());
    _$insert(_el$37, _$createComponent(Show, {
      when: coverArt,
      get children() {
        var _el$38 = _tmpl$30();
        _$setAttribute(_el$38, "src", coverArt);
        _$effect(_$p => _$classList(_el$38, {
          "bg-gray-300 size-24 sm:size-32 select-none": true,
          "rounded-xl": !open(),
          "rounded-tl-xl": open()
        }, _$p));
        return _el$38;
      }
    }), null);
    _$insert(_el$37, _$createComponent(Show, {
      when: !coverArt,
      get children() {
        var _el$39 = _tmpl$31();
        _$effect(_$p => _$classList(_el$39, {
          "size-24 sm:size-32 bg-gray-300": true,
          "rounded-xl": !open(),
          "rounded-tl-xl": open()
        }, _$p));
        return _el$39;
      }
    }), null);
    _$insert(_el$37, () => rankBadge([index + 1, "deck-darlings"]), null);
    _$insert(_el$41, () => track.trackTitle);
    _$insert(_el$42, () => track.albumAuthor);
    _$insert(_el$35, _$createComponent(Show, {
      get when() {
        return open();
      },
      get children() {
        return [(() => {
          var _el$43 = _tmpl$32();
          _$insert(_el$43, _$createComponent(EmbeddableAudio, {
            get url() {
              return track.trackEnclosureUrl;
            }
          }));
          return _el$43;
        })(), (() => {
          var _el$44 = _tmpl$33(),
            _el$45 = _el$44.firstChild,
            _el$46 = _el$45.nextSibling;
          _$insert(_el$46, _$createComponent(For, {
            get each() {
              return track.referencingItems;
            },
            children: item => (() => {
              var _el$47 = _tmpl$36(),
                _el$48 = _el$47.firstChild,
                _el$49 = _el$48.firstChild,
                _el$51 = _el$49.nextSibling,
                _el$54 = _el$51.nextSibling,
                _el$55 = _el$54.nextSibling,
                _el$56 = _el$55.firstChild,
                _el$57 = _el$56.nextSibling;
              _$insert(_el$47, _$createComponent(Icon, {
                path: HeroMini.musicalNote,
                "class": "size-5 mr-4"
              }), _el$48);
              _$insert(_el$49, _$createComponent(Show, {
                get when() {
                  return item.feedLinkUrl;
                },
                get fallback() {
                  return item.feedTitle;
                },
                get children() {
                  var _el$50 = _tmpl$35();
                  _$insert(_el$50, () => item.feedTitle);
                  _$effect(() => _$setAttribute(_el$50, "href", item.feedLinkUrl));
                  return _el$50;
                }
              }));
              _$insert(_el$57, _$createComponent(Show, {
                get when() {
                  return item.itemLinkUrl && item.itemLinkUrl != item.feedLinkUrl;
                },
                get fallback() {
                  return item.itemTitle;
                },
                get children() {
                  var _el$58 = _tmpl$35();
                  _$insert(_el$58, () => item.itemTitle);
                  _$effect(() => _$setAttribute(_el$58, "href", item.itemLinkUrl));
                  return _el$58;
                }
              }));
              _$effect(() => _el$54.innerHTML = timestampToLocalDate(new Date(item.itemPublishedAt)));
              return _el$47;
            })()
          }));
          return _el$44;
        })()];
      }
    }), null);
    _$effect(_p$ => {
      var _v$ = {
          "flex flex-col rounded-xl border": true,
          "hover:bg-gray-200 border-transparent": !open(),
          "bg-white border-gray-300 shadow-lg": open()
        },
        _v$2 = `deck-darlings-${track.albumGuid.toString()}-${track.trackGuid}`,
        _v$3 = {
          "flex items-center gap-x-7 cursor-pointer": true,
          "border-b border-gray-200": open()
        };
      _p$.e = _$classList(_el$35, _v$, _p$.e);
      _v$2 !== _p$.t && _$setAttribute(_el$35, "id", _p$.t = _v$2);
      _p$.a = _$classList(_el$36, _v$3, _p$.a);
      return _p$;
    }, {
      e: undefined,
      t: undefined,
      a: undefined
    });
    return _el$35;
  })();
}
function TopReferencingFeed([feed, index]) {
  const [open, setOpen] = createSignal(false);
  const coverArt = feed.coverArtUrl;

  // clone
  const referencedTracksByScore = feed.firstTimeReferences.map(x => x).sort(([,, deckDarlingsRankA, paydayPicksRankA], [,, deckDarlingsRankB, paydayPicksRankB]) => {
    let scoreA = 0;
    if (deckDarlingsRankA) {
      scoreA += 2 * 0.5 ** ((deckDarlingsRankA - 1) / 10);
    }
    if (paydayPicksRankA) {
      scoreA += 0.5 ** ((paydayPicksRankA - 1) / 10);
    }
    let scoreB = 0;
    if (deckDarlingsRankB) {
      scoreB += 2 * 0.5 ** ((deckDarlingsRankB - 1) / 10);
    }
    if (paydayPicksRankB) {
      scoreB += 0.5 ** ((paydayPicksRankB - 1) / 10);
    }
    return scoreB - scoreA;
  });
  const [scoreString, rounded] = formatScore(feed.score);
  return (() => {
    var _el$59 = _tmpl$40(),
      _el$60 = _el$59.firstChild,
      _el$61 = _el$60.firstChild,
      _el$64 = _el$61.nextSibling,
      _el$65 = _el$64.firstChild,
      _el$66 = _el$65.nextSibling;
    _el$60.$$click = () => setOpen(!open());
    _$insert(_el$61, _$createComponent(Show, {
      when: coverArt,
      get children() {
        var _el$62 = _tmpl$30();
        _$setAttribute(_el$62, "src", coverArt);
        _$effect(_$p => _$classList(_el$62, {
          "bg-gray-300 size-24 sm:size-32 select-none": true,
          "rounded-xl": !open(),
          "rounded-tl-xl": open()
        }, _$p));
        return _el$62;
      }
    }), null);
    _$insert(_el$61, _$createComponent(Show, {
      when: !coverArt,
      get children() {
        var _el$63 = _tmpl$31();
        _$effect(_$p => _$classList(_el$63, {
          "size-24 sm:size-32 bg-gray-300": true,
          "rounded-xl": !open(),
          "rounded-tl-xl": open()
        }, _$p));
        return _el$63;
      }
    }), null);
    _$insert(_el$61, () => rankBadge([index + 1, "pathfinders"]), null);
    _$insert(_el$65, () => feed.title);
    _$insert(_el$66, () => feed.author);
    _$insert(_el$59, _$createComponent(Show, {
      get when() {
        return open();
      },
      get children() {
        var _el$67 = _tmpl$39(),
          _el$71 = _el$67.firstChild;
        _$insert(_el$67, _$createComponent(Popover, {
          fitViewport: true,
          get children() {
            return [_$createComponent(Popover.Trigger, {
              "class": "text-gray-800 text-lg font-bold mb-4 cursor-help flex items-center",
              get children() {
                return [_$createComponent(Icon, {
                  path: HeroMini.informationCircle,
                  "class": "size-5 mr-4"
                }), _tmpl$37()];
              }
            }), _$createComponent(Popover.Portal, {
              get children() {
                return _$createComponent(Popover.Content, {
                  "class": "bg-white px-4 pt-2 pb-3 border border-gray-300 shadow-xl not-prose rounded-xl max-w-72 sm:max-w-prose z-50",
                  get children() {
                    return [_$createComponent(Popover.Arrow, {}), (() => {
                      var _el$69 = _tmpl$28();
                      _$insert(_el$69, _$createComponent(Popover.Title, {
                        "class": "font-bold text-lg",
                        get children() {
                          return _$createComponent(Show, {
                            when: rounded,
                            fallback: `Score ≈ ${scoreString}`,
                            get children() {
                              return ["Score \u2248 ", scoreString];
                            }
                          });
                        }
                      }), null);
                      _$insert(_el$69, _$createComponent(Popover.CloseButton, {
                        get children() {
                          return _$createComponent(Icon, {
                            path: HeroMini.xMark,
                            "class": "size-5"
                          });
                        }
                      }), null);
                      return _el$69;
                    })(), _$createComponent(Popover.Description, {
                      get children() {
                        var _el$70 = _tmpl$38();
                        _$insert(_el$70, _$createComponent(For, {
                          each: referencedTracksByScore,
                          children: ([_referencingItem, referencedTrack, deckDarlingsRank, paydayPicksRank]) => (() => {
                            var _el$72 = _tmpl$41(),
                              _el$73 = _el$72.firstChild;
                            _$insert(_el$72, _$createComponent(ReferencedTrackTitle, [referencedTrack]), _el$73);
                            _$insert(_el$72, _$createComponent(ReferencedTrackScoreCalculation, [deckDarlingsRank, paydayPicksRank]), null);
                            return _el$72;
                          })()
                        }));
                        return _el$70;
                      }
                    })];
                  }
                });
              }
            })];
          }
        }), _el$71);
        _$insert(_el$71, _$createComponent(For, {
          get each() {
            return feed.firstTimeReferences;
          },
          children: ([referencingItem, referencedTrack, deckDarlingsRank, paydayPicksRank]) => (() => {
            var _el$74 = _tmpl$44(),
              _el$75 = _el$74.firstChild,
              _el$78 = _el$75.firstChild,
              _el$80 = _el$78.nextSibling,
              _el$82 = _el$80.nextSibling,
              _el$85 = _el$82.nextSibling,
              _el$86 = _el$85.nextSibling,
              _el$87 = _el$86.firstChild,
              _el$88 = _el$87.nextSibling;
            _$insert(_el$74, _$createComponent(Icon, {
              path: HeroMini.musicalNote,
              "class": "size-5 mr-4"
            }), _el$75);
            _$insert(_el$75, _$createComponent(ReferencedTrackTitle, [referencedTrack]), _el$78);
            _$insert(_el$75, _$createComponent(Show, {
              when: deckDarlingsRank,
              get children() {
                var _el$76 = _tmpl$42();
                _$setAttribute(_el$76, "title", `Deck Darlings rank: ${deckDarlingsRank}`);
                _$insert(_el$76, deckDarlingsRank);
                return _el$76;
              }
            }), _el$78);
            _$insert(_el$75, _$createComponent(Show, {
              when: paydayPicksRank,
              get children() {
                var _el$77 = _tmpl$43();
                _$setAttribute(_el$77, "title", `Payday Picks rank: ${paydayPicksRank}`);
                _$insert(_el$77, paydayPicksRank);
                _$effect(_$p => _$classList(_el$77, {
                  "inline-flex mr-2 bg-yellow-500 text-gray-800 size-6 font-bold rounded-full text-xs items-center justify-center select-none": true,
                  "ml-1.5": !deckDarlingsRank
                }, _$p));
                return _el$77;
              }
            }), _el$78);
            _$insert(_el$80, _$createComponent(Show, {
              get when() {
                return referencedTrack.albumLinkUrl;
              },
              get fallback() {
                return referencedTrack.albumAuthor;
              },
              get children() {
                var _el$81 = _tmpl$35();
                _$insert(_el$81, () => referencedTrack.albumAuthor);
                _$effect(() => _$setAttribute(_el$81, "href", referencedTrack.albumLinkUrl));
                return _el$81;
              }
            }));
            _$insert(_el$88, _$createComponent(Show, {
              get when() {
                return referencingItem.itemLinkUrl;
              },
              get fallback() {
                return referencingItem.itemTitle;
              },
              get children() {
                var _el$89 = _tmpl$35();
                _$insert(_el$89, () => referencingItem.itemTitle);
                _$effect(() => _$setAttribute(_el$89, "href", referencingItem.itemLinkUrl));
                return _el$89;
              }
            }));
            _$effect(() => _el$85.innerHTML = timestampToLocalDate(new Date(referencingItem.itemPublishedAt)));
            return _el$74;
          })()
        }));
        return _el$67;
      }
    }), null);
    _$effect(_p$ => {
      var _v$4 = {
          "flex flex-col rounded-xl border": true,
          "hover:bg-gray-200 border-transparent": !open(),
          "bg-white border-gray-300 shadow-lg": open()
        },
        _v$5 = `pathfinders-${feed.guid}`,
        _v$6 = {
          "flex items-center gap-x-7 cursor-pointer": true,
          "border-b border-gray-200": open()
        };
      _p$.e = _$classList(_el$59, _v$4, _p$.e);
      _v$5 !== _p$.t && _$setAttribute(_el$59, "id", _p$.t = _v$5);
      _p$.a = _$classList(_el$60, _v$6, _p$.a);
      return _p$;
    }, {
      e: undefined,
      t: undefined,
      a: undefined
    });
    return _el$59;
  })();
}
function TopBoostedTrack([track, index]) {
  const [open, setOpen] = createSignal(false);
  const coverArt = track.trackCoverArtUrl || track.albumCoverArtUrl;
  return (() => {
    var _el$90 = _tmpl$34(),
      _el$91 = _el$90.firstChild,
      _el$92 = _el$91.firstChild,
      _el$95 = _el$92.nextSibling,
      _el$96 = _el$95.firstChild,
      _el$97 = _el$96.nextSibling;
    _el$91.$$click = () => setOpen(!open());
    _$insert(_el$92, _$createComponent(Show, {
      when: coverArt,
      get children() {
        var _el$93 = _tmpl$30();
        _$setAttribute(_el$93, "src", coverArt);
        _$effect(_$p => _$classList(_el$93, {
          "bg-gray-300 size-24 sm:size-32 select-none": true,
          "rounded-xl": !open(),
          "rounded-tl-xl": open()
        }, _$p));
        return _el$93;
      }
    }), null);
    _$insert(_el$92, _$createComponent(Show, {
      when: !coverArt,
      get children() {
        var _el$94 = _tmpl$31();
        _$effect(_$p => _$classList(_el$94, {
          "size-24 sm:size-32 bg-gray-300": true,
          "rounded-xl": !open(),
          "rounded-tl-xl": open()
        }, _$p));
        return _el$94;
      }
    }), null);
    _$insert(_el$92, () => rankBadge([index + 1, "payday-picks"]), null);
    _$insert(_el$96, () => track.trackTitle);
    _$insert(_el$97, () => track.albumAuthor);
    _$insert(_el$90, _$createComponent(Show, {
      get when() {
        return open();
      },
      get children() {
        var _el$98 = _tmpl$45();
        _$insert(_el$98, _$createComponent(EmbeddableAudio, {
          get url() {
            return track.trackEnclosureUrl;
          }
        }));
        return _el$98;
      }
    }), null);
    _$effect(_p$ => {
      var _v$7 = {
          "flex flex-col rounded-xl border ": true,
          "hover:bg-gray-200 border-transparent": !open(),
          "bg-white border-gray-300 shadow-lg": open()
        },
        _v$8 = `payday-picks-${track.albumGuid}-${track.trackGuid}`,
        _v$9 = {
          "flex items-center gap-x-7 cursor-pointer": true,
          "border-b border-gray-200": open()
        };
      _p$.e = _$classList(_el$90, _v$7, _p$.e);
      _v$8 !== _p$.t && _$setAttribute(_el$90, "id", _p$.t = _v$8);
      _p$.a = _$classList(_el$91, _v$9, _p$.a);
      return _p$;
    }, {
      e: undefined,
      t: undefined,
      a: undefined
    });
    return _el$90;
  })();
}
function rankBadge([rank, tab]) {
  return (() => {
    var _el$99 = _tmpl$31();
    _$insert(_el$99, rank);
    _$effect(_$p => _$classList(_el$99, {
      "absolute flex items-center -top-3 -right-3 rounded-full size-9 font-bold justify-center": true,
      "text-xl sm:text-2xl sm:size-10": rank <= 10,
      "bg-red-600 text-white": tab === "deck-darlings",
      "bg-yellow-500 text-gray-800": tab === "payday-picks",
      "bg-primary-700 text-white": tab === "pathfinders"
    }, _$p));
    return _el$99;
  })();
}
function ReferencedTrackTitle([track]) {
  return (() => {
    var _el$100 = _tmpl$47(),
      _el$102 = _el$100.firstChild;
    _$insert(_el$100, _$createComponent(Show, {
      get when() {
        return track.trackLinkUrl || track.albumLinkUrl;
      },
      get fallback() {
        return track.trackTitle;
      },
      get children() {
        var _el$101 = _tmpl$46();
        _$insert(_el$101, () => track.trackTitle);
        _$effect(() => _$setAttribute(_el$101, "href", track.trackLinkUrl || track.albumLinkUrl));
        return _el$101;
      }
    }), _el$102);
    return _el$100;
  })();
}
function ReferencedTrackScoreCalculation([deckDarlingsRank, paydayPicksRank]) {
  if (deckDarlingsRank && paydayPicksRank) {
    const [scoreStr, rounded] = formatScore(2 * 0.5 ** ((deckDarlingsRank - 1) / 10) + 0.5 ** ((paydayPicksRank - 1) / 10));
    return (() => {
      var _el$103 = _tmpl$48(),
        _el$104 = _el$103.firstChild,
        _el$105 = _el$104.nextSibling,
        _el$106 = _el$105.firstChild,
        _el$107 = _el$106.nextSibling,
        _el$108 = _el$105.nextSibling,
        _el$110 = _el$108.nextSibling,
        _el$111 = _el$110.firstChild,
        _el$112 = _el$111.nextSibling,
        _el$113 = _el$110.nextSibling,
        _el$115 = _el$113.nextSibling,
        _el$114 = _el$115.nextSibling;
      _$insert(_el$107, deckDarlingsRank);
      _$insert(_el$112, paydayPicksRank);
      _$insert(_el$103, _$createComponent(Show, {
        when: rounded,
        fallback: "=",
        children: "\u2248"
      }), _el$115);
      _$insert(_el$103, scoreStr, null);
      return _el$103;
    })();
  }
  if (deckDarlingsRank) {
    const [scoreStr, rounded] = formatScore(2 * 0.5 ** ((deckDarlingsRank - 1) / 10));
    return (() => {
      var _el$116 = _tmpl$49(),
        _el$117 = _el$116.firstChild,
        _el$118 = _el$117.nextSibling,
        _el$119 = _el$118.firstChild,
        _el$120 = _el$119.nextSibling,
        _el$121 = _el$118.nextSibling,
        _el$123 = _el$121.nextSibling,
        _el$122 = _el$123.nextSibling;
      _$insert(_el$120, deckDarlingsRank);
      _$insert(_el$116, _$createComponent(Show, {
        when: rounded,
        fallback: "=",
        children: "\u2248"
      }), _el$123);
      _$insert(_el$116, scoreStr, null);
      return _el$116;
    })();
  }
  if (paydayPicksRank) {
    const [scoreStr, rounded] = formatScore(0.5 ** ((paydayPicksRank - 1) / 10));
    return (() => {
      var _el$124 = _tmpl$50(),
        _el$125 = _el$124.firstChild,
        _el$126 = _el$125.nextSibling,
        _el$127 = _el$126.firstChild,
        _el$128 = _el$127.nextSibling,
        _el$129 = _el$126.nextSibling,
        _el$131 = _el$129.nextSibling,
        _el$130 = _el$131.nextSibling;
      _$insert(_el$128, paydayPicksRank);
      _$insert(_el$124, _$createComponent(Show, {
        when: rounded,
        fallback: "=",
        children: "\u2248"
      }), _el$131);
      _$insert(_el$124, scoreStr, null);
      return _el$124;
    })();
  }
}

// Returns string score and whether rounded.
function formatScore(score) {
  if (score >= 0.01) {
    const fixed = score.toFixed(2);
    if (fixed === score.toString()) {
      return [fixed, false];
    }
    // Might be a whole number.
    if (score.toFixed(0) === score.toString()) {
      return [score.toFixed(0), false];
    }
    // Might be a number with one decimal place.
    if (score.toFixed(1) === score.toString()) {
      return [score.toFixed(1), false];
    }
    return [fixed, true];
  }
  return ["0.01", true];
}
function renderApp() {
  const app = document.getElementById("app");
  if (app) {
    render(() => _$createComponent(App, {}), app);
  }
}
renderApp();
_$delegateEvents(["click"]);